/* Sole product controller. Rate UI subscribes to mediatech:variant-change. */
(function () {
  'use strict';
  if (window.MediaTechProductController) { window.MediaTechProductController.initializeAll(); return; }
  function initialize(root) {
    if (root.mtProductController) return;
    var product = {}, variants = [];
    try {
      var full = root.querySelector('[data-mt-product-json]');
      var partial = root.querySelector('[data-mt-variants-json]');
      if (full) { product = JSON.parse(full.textContent); variants = product.variants || []; }
      else if (partial) variants = JSON.parse(partial.textContent);
    } catch (error) { return; }
    if (!Array.isArray(variants)) variants = variants && variants.id != null ? [variants] : [];
    var productId = root.dataset.productId || (product.id != null ? String(product.id) : null);
    var highVariants = Number(root.dataset.variantCount) > 250;
    var serverSelectionValid = root.dataset.selectionValid !== 'false';
    var internalProduct = root.dataset.internal === 'true';
    var authoritativeVariant = null, pending = false, disposed = false, requestGeneration = 0, fetchController = null, fetchTimer = null;
    var currency = root.dataset.currency || (window.MediaTech && window.MediaTech.currency) || 'EUR';
    var locale = root.dataset.locale || document.documentElement.lang || 'it-IT';
    var cartBase = root.dataset.cartUrl || (window.MediaTech && window.MediaTech.routes && window.MediaTech.routes.cart) || '/cart';
    // Native cart permalinks must stay on this shop and use a cart route.
    try { var parsedCart = new URL(cartBase,location.origin); cartBase = parsedCart.origin === location.origin && /\/cart\/?$/.test(parsedCart.pathname) ? parsedCart.pathname.replace(/\/$/,'') : '/cart'; } catch (error) { cartBase = '/cart'; }
    var qty = root.querySelector('[data-mt-qty]');
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mt-option-value]'));
    var selects = Array.prototype.slice.call(root.querySelectorAll('select[data-mt-option]'));
    var buy = root.querySelector('[data-mt-buy]');
    var addButton = root.querySelector('[data-mt-add]'), cartAdding = false;
    var stickyBuy = root.querySelector('[data-mt-buy-sticky]');
    var links = [buy,stickyBuy].filter(Boolean);
    var media = Array.prototype.slice.call(root.querySelectorAll('[data-mt-media]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mt-thumb]'));
    var prev = root.querySelector('[data-mt-gallery-prev]'), next = root.querySelector('[data-mt-gallery-next]');
    var zoomButton = root.querySelector('[data-mt-zoom]');
    var dialog = root.querySelector('[data-mt-zoom-dialog]');
    var zoomImage = dialog && dialog.querySelector('[data-mt-zoom-image]');
    var zoomClose = dialog && dialog.querySelector('[data-mt-zoom-close]');
    var sticky = root.querySelector('[data-mt-sticky]');
    var mql = window.matchMedia('(max-width: 749px)');
    var current = null, selections = [], mediaIndex = 0, lastKey = null, state = null;
    var originalTabs = new WeakMap(), availableLabels = new WeakMap();
    links.forEach(function (link) {
      originalTabs.set(link,link.getAttribute('tabindex'));
      var label = link.querySelector('[data-mt-buy-label]');
      availableLabels.set(link,link.getAttribute('data-mt-available-label') || (label && label.textContent.trim() !== 'Non disponibile' ? label.textContent.trim() : 'Acquista ora'));
    });
    function text(selector,value) { var el = root.querySelector(selector); if (el) el.textContent = value; }
    function money(cents) { try { return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(Number(cents)/100); } catch (error) { return (Number(cents)/100).toFixed(2)+' '+currency; } }
    function values(variant) {
      if (Array.isArray(variant.options)) return variant.options.map(String);
      return [variant.option1,variant.option2,variant.option3].filter(function (v) { return v != null; }).map(String);
    }
    function variantById(id) { return variants.find(function (v) { return String(v.id) === String(id); }) || null; }
    function matchSelection() { if (!serverSelectionValid) return null; if (highVariants) return authoritativeVariant; return variants.find(function (v) { var opts=values(v); return opts.length===selections.length && opts.every(function (v,i) { return v===selections[i]; }); }) || null; }
    function limits(variant) {
      var rule = variant && variant.quantity_rule || {};
      var min = Math.max(1,Math.floor(Number(rule.min)||1)), step = Math.max(1,Math.floor(Number(rule.increment)||1));
      var max = Number(rule.max)>0 ? Math.floor(Number(rule.max)) : 99;
      max=Math.min(99,max);
      if (variant && variant.inventory_management && String(variant.inventory_policy).toLowerCase()==='deny' && Number.isFinite(Number(variant.inventory_quantity))) max=Math.min(max,Math.max(0,Math.floor(Number(variant.inventory_quantity))));
      return {min:min,max:max,step:step};
    }
    function quantity(variant,delta) {
      var rule=limits(variant), number=Number(qty ? qty.value : rule.min);
      if (!Number.isFinite(number)) number=rule.min;
      number=Math.max(rule.min,Math.floor(number));
      number=rule.min+Math.floor((number-rule.min)/rule.step)*rule.step+(delta||0)*rule.step;
      var maxAllowed=rule.min+Math.floor((rule.max-rule.min)/rule.step)*rule.step;
      number=Math.max(rule.min,Math.min(number,maxAllowed));
      if (qty) { qty.value=String(number); qty.min=String(rule.min); qty.step=String(rule.step); qty.max=String(Math.max(rule.min,rule.max)); }
      var minus=root.querySelector('[data-mt-qty-minus]'), plus=root.querySelector('[data-mt-qty-plus]');
      if (minus) minus.disabled=number<=rule.min;
      if (plus) plus.disabled=rule.max<rule.min || number+rule.step>rule.max;
      return {value:number,valid:rule.max>=rule.min && number<=rule.max};
    }
    function updateOptions() {
      if (highVariants) {
        // The server has the complete option tree; the JSON cache is intentionally partial.
        optionButtons.forEach(function (button) {
          var selected=selections[Number(button.dataset.optionIndex)]===String(button.dataset.optionValue);
          button.classList.toggle('is-selected',selected);
          button.setAttribute('aria-pressed',selected?'true':'false');
          if (button.dataset.optionAvailable!=null) button.classList.toggle('is-unavailable',button.dataset.optionAvailable==='false');
        });
        selects.forEach(function (select,index) { index=select.dataset.optionIndex!=null?Number(select.dataset.optionIndex):index; if (selections[index]!=null) select.value=selections[index]; });
        selections.forEach(function (value,index) { text('[data-mt-option-selected="'+index+'"]',value); text('[data-mt-selected-option="'+index+'"]',value); });
        return;
      }
      optionButtons.forEach(function (button) {
        var index=Number(button.dataset.optionIndex), value=String(button.dataset.optionValue);
        var matches=variants.filter(function (v) { var opts=values(v); return opts[index]===value && opts.every(function (opt,i) { return i>=index || opt===selections[i]; }); });
        button.disabled=!matches.length;
        button.classList.toggle('is-unavailable',!matches.some(function (v) { return v.available===true; }));
        button.classList.toggle('is-selected',selections[index]===value);
        button.setAttribute('aria-pressed',selections[index]===value ? 'true' : 'false');
      });
      selects.forEach(function (select,index) {
        index=select.dataset.optionIndex != null ? Number(select.dataset.optionIndex) : index;
        if (selections[index]!=null) select.value=selections[index];
        Array.prototype.forEach.call(select.options,function (option) {
          option.disabled=!variants.some(function (v) { var opts=values(v); return opts[index]===String(option.value) && opts.every(function (opt,i) { return i>=index || opt===selections[i]; }); });
        });
      });
      selections.forEach(function (selection,index) {
        text('[data-mt-option-selected="'+index+'"]',selection);
        text('[data-mt-selected-option="'+index+'"]',selection);
      });
    }
    function currentImage() {
      var item=media[mediaIndex];
      return item && (item.matches('img') ? item : item.querySelector('img'));
    }
    function showMedia(index) {
      if (!media.length) return;
      mediaIndex=(index+media.length)%media.length;
      media.forEach(function (item,i) {
        item.hidden=i!==mediaIndex; item.classList.toggle('is-active',i===mediaIndex); item.classList.toggle('is-hidden',i!==mediaIndex);
        if (i!==mediaIndex) item.querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
      var id=media[mediaIndex].getAttribute('data-mt-media');
      thumbs.forEach(function (thumb) { var active=thumb.getAttribute('data-mt-thumb')===id; thumb.classList.toggle('is-active',active); thumb.setAttribute('aria-pressed',active?'true':'false'); });
      var activeThumb=thumbs.find(function (thumb) { return thumb.getAttribute('data-mt-thumb')===id; });
      if (activeThumb && activeThumb.parentElement) {
        var rail=activeThumb.parentElement, box=rail.getBoundingClientRect(), thumbBox=activeThumb.getBoundingClientRect();
        var offset=thumbBox.left<box.left ? thumbBox.left-box.left : thumbBox.right>box.right ? thumbBox.right-box.right : 0;
        if (offset && rail.scrollTo) rail.scrollTo({left:rail.scrollLeft+offset,behavior:'smooth'});
      }
      if (zoomButton) zoomButton.disabled=!currentImage();
    }
    function variantMedia(variant) {
      var id=variant && (variant.featured_media_id || variant.featured_media && variant.featured_media.id);
      var index=media.findIndex(function (item) { return String(item.getAttribute('data-mt-media'))===String(id); });
      if (index>=0) showMedia(index);
    }
    function render(emit,changeMedia,delta) {
      current=pending || disposed ? null : matchSelection();
      var number=quantity(current,delta), cents=current ? Number(current.price) : null;
      var available=!!(!internalProduct && !pending && !disposed && current && current.available===true && number.valid && Number.isFinite(cents) && cents>0);
      var id=current ? String(current.id) : null;
      root.dataset.selectedVariantId=id||''; root.dataset.currentVariant=id||'';
      text('[data-mt-price]',current?money(cents):'—'); text('[data-mt-sticky-price]',current?money(cents):'—'); text('[data-mt-sku]',current && current.sku || '—');
      var compare=Number(current && current.compare_at_price)||0, sale=!!current && compare>cents;
      var compareEl=root.querySelector('[data-mt-compare]'); if (compareEl) { compareEl.hidden=!sale; compareEl.textContent=sale?money(compare):''; }
      var saving=root.querySelector('[data-mt-saving]'); if (saving) saving.hidden=!sale;
      text('[data-mt-saving-value]',sale?money(compare-cents):'');
      var discount=root.querySelector('[data-mt-discount]'); if (discount) { discount.hidden=!sale; discount.textContent=sale?'-'+Math.round((compare-cents)/compare*100)+'%':''; }
      var stock=root.querySelector('[data-mt-stock]'); if (stock) { stock.classList.toggle('is-in',available); stock.classList.toggle('is-out',!available); stock.classList.toggle('is-unavailable',!available); }
      text('[data-mt-stock-text]',available?'Disponibile':'Non disponibile');
      links.forEach(function (link) {
        link.classList.toggle('is-disabled',!available); link.setAttribute('aria-disabled',available?'false':'true');
        var label=link.querySelector('[data-mt-buy-label]');
        if (label) label.textContent=available?availableLabels.get(link):'Non disponibile';
        else if (link===stickyBuy) link.textContent=available?availableLabels.get(link):'Non disponibile';
        if (available) { link.href=cartBase+'/'+encodeURIComponent(id)+':'+number.value; var tab=originalTabs.get(link); if (tab==null || tab==='-1') link.removeAttribute('tabindex'); else link.setAttribute('tabindex',tab); }
        else { link.removeAttribute('href'); link.setAttribute('tabindex','-1'); }
      });
      if (addButton) {
        addButton.disabled=!available || cartAdding;
        addButton.setAttribute('aria-disabled',addButton.disabled?'true':'false');
        addButton.setAttribute('aria-busy',cartAdding?'true':'false');
        addButton.textContent=cartAdding?addButton.dataset.busyLabel:available?addButton.dataset.label:addButton.dataset.unavailableLabel;
      }
      if (!available) root.querySelectorAll('[data-payment24-open]').forEach(function (opener) { opener.disabled=true; opener.setAttribute('aria-disabled','true'); });
      updateOptions();
      if (changeMedia) variantMedia(current);
      state={productId:productId,variantId:id,quantity:number.value,available:available,priceCents:cents};
      var key=JSON.stringify(state);
      if (emit && lastKey!==null && key!==lastKey) root.dispatchEvent(new CustomEvent('mediatech:variant-change',{detail:Object.assign({},state),bubbles:true}));
      lastKey=key;
      return state;
    }
    function showRequestMessage(message,busy) {
      root.setAttribute('aria-busy',busy?'true':'false');
      var el=root.querySelector('[data-mt-product-error]');
      if (el) { el.hidden=!message; el.textContent=message||''; }
    }
    function selectedOptionIds() {
      var ids=[];
      if (selects.length) {
        selects.forEach(function (select,index) {
          index=select.dataset.optionIndex!=null?Number(select.dataset.optionIndex):index;
          var option=Array.prototype.find.call(select.options,function (o) { return String(o.value)===selections[index]; });
          ids[index]=option && option.dataset.optionValueId;
        });
      } else {
        selections.forEach(function (value,index) {
          var button=optionButtons.find(function (b) { return Number(b.dataset.optionIndex)===index && String(b.dataset.optionValue)===value; });
          ids[index]=button && button.dataset.optionValueId;
        });
      }
      if (!ids.length || ids.length!==selections.length || ids.some(function (id) { return !id || !/^\d+$/.test(String(id)); })) throw Error('Option IDs unavailable');
      return ids.map(String);
    }
    async function loadHighVariantSelection() {
      var generation=++requestGeneration;
      if (fetchController) fetchController.abort();
      if (fetchTimer) clearTimeout(fetchTimer);
      fetchController=new AbortController();
      pending=true; authoritativeVariant=null; serverSelectionValid=false;
      showRequestMessage('Aggiornamento configurazione…',true);
      render(true,false);
      try {
        var ids=selectedOptionIds(), sectionId=root.dataset.sectionId;
        if (!sectionId) throw Error('Section ID unavailable');
        var url=new URL(location.href);
        var productUrl=new URL(root.dataset.productUrl || location.pathname,location.origin);
        if (productUrl.origin!==location.origin) throw Error('Unexpected product origin');
        url.pathname=productUrl.pathname;
        url.searchParams.delete('variant'); url.searchParams.delete('sections');
        url.searchParams.set('section_id',sectionId);
        url.searchParams.set('option_values',ids.join(','));
        var controller=fetchController;
        fetchTimer=setTimeout(function () { controller.abort(); },30000);
        var response=await fetch(url.toString(),{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if (!response.ok) throw Error('Section rendering failed');
        var markup=await response.text();
        if (disposed || generation!==requestGeneration || !root.isConnected) return;
        var parsed=new DOMParser().parseFromString(markup,'text/html');
        var replacement=Array.prototype.find.call(parsed.querySelectorAll('[data-mt-product-root]'),function (node) { return String(node.dataset.productId)===String(productId) && String(node.dataset.sectionId)===String(sectionId); });
        if (!replacement) throw Error('Unexpected product section');
        var replacementQty=replacement.querySelector('[data-mt-qty]');
        if (replacementQty && qty) replacementQty.value=qty.value;
        var focusIndex=Number(document.activeElement && document.activeElement.dataset.optionIndex);
        var focusValue=document.activeElement && document.activeElement.dataset.optionValueId;
        if (disposed || generation!==requestGeneration) return;
        if (fetchTimer) clearTimeout(fetchTimer);
        var pageUrl=new URL(location.href);
        pageUrl.searchParams.set('option_values',ids.join(','));
        pageUrl.searchParams.delete('section_id'); pageUrl.searchParams.delete('sections');
        if (replacement.dataset.selectionValid!=='false' && replacement.dataset.currentVariant) pageUrl.searchParams.set('variant',replacement.dataset.currentVariant); else pageUrl.searchParams.delete('variant');
        history.replaceState({},'',pageUrl.toString());
        // Only this root is replaced; new payment custom elements reconnect with fresh consent.
        root.mtProductController.destroy();
        root.replaceWith(replacement);
        initialize(replacement);
        var nextState=replacement.mtProductController && replacement.mtProductController.getState();
        if (nextState) replacement.dispatchEvent(new CustomEvent('mediatech:variant-change',{detail:nextState,bubbles:true}));
        var focusTarget=Array.prototype.find.call(replacement.querySelectorAll('[data-mt-option-value]'),function (b) { return Number(b.dataset.optionIndex)===focusIndex && b.dataset.optionValueId===focusValue; });
        if (focusTarget) focusTarget.focus({preventScroll:true});
      } catch (error) {
        if (disposed || generation!==requestGeneration) return;
        pending=false; authoritativeVariant=null; serverSelectionValid=false;
        showRequestMessage('Non è stato possibile aggiornare questa configurazione. Ricarica la pagina o scegli di nuovo le opzioni.',false);
        render(true,false);
      } finally {
        if (generation===requestGeneration && fetchTimer) { clearTimeout(fetchTimer); fetchTimer=null; }
      }
    }
    function variantChoice() {
      if (highVariants) { updateOptions(); loadHighVariantSelection(); return; }
      serverSelectionValid=true;
      showRequestMessage('',false);
      var state=render(true,true);
      root.dataset.selectionValid=state.variantId?'true':'false';
      var url=new URL(location.href);
      if (state.variantId) url.searchParams.set('variant',state.variantId); else url.searchParams.delete('variant');
      history.replaceState({},'',url.toString());
    }
    optionButtons.forEach(function (button) { button.addEventListener('click',function () { if (button.disabled) return; selections[Number(button.dataset.optionIndex)]=String(button.dataset.optionValue); variantChoice(); }); });
    selects.forEach(function (select,index) { select.addEventListener('change',function () { index=select.dataset.optionIndex!=null ? Number(select.dataset.optionIndex) : index; selections[index]=String(select.value); variantChoice(); }); });
    var minus=root.querySelector('[data-mt-qty-minus]'), plus=root.querySelector('[data-mt-qty-plus]');
    if (minus) minus.addEventListener('click',function () { render(true,false,-1); });
    if (plus) plus.addEventListener('click',function () { render(true,false,1); });
    if (qty) { qty.addEventListener('input',function () { render(true,false); }); qty.addEventListener('change',function () { render(true,false); }); }
    links.forEach(function (link) { link.addEventListener('click',function (event) { if (!render(true,false).available) { event.preventDefault(); event.stopImmediatePropagation(); } },true); });
    if (addButton) addButton.addEventListener('click',async function () {
      if (cartAdding || disposed) return;
      var selected=render(true,false);
      if (!selected.available) return;
      cartAdding=true;
      showRequestMessage('',false);
      render(false,false);
      try {
        if (!window.MediaTechCart || typeof window.MediaTechCart.add!=='function') throw Error('Cart unavailable');
        await window.MediaTechCart.add({items:[{id:Number(selected.variantId),quantity:selected.quantity}]},addButton);
      } catch (error) {
        if (!disposed && root.isConnected) showRequestMessage(addButton.dataset.errorLabel,false);
      } finally {
        cartAdding=false;
        if (!disposed && root.isConnected) render(false,false);
      }
    });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click',function () { var index=media.findIndex(function (item) { return item.getAttribute('data-mt-media')===thumb.getAttribute('data-mt-thumb'); }); if (index>=0) showMedia(index); }); });
    if (prev) { prev.disabled=media.length<=1; prev.addEventListener('click',function () { showMedia(mediaIndex-1); }); }
    if (next) { next.disabled=media.length<=1; next.addEventListener('click',function () { showMedia(mediaIndex+1); }); }
    if (zoomButton) zoomButton.addEventListener('click',function () {
      var image=currentImage(); if (!image || !dialog || !zoomImage) return;
      zoomImage.src=image.getAttribute('data-mt-zoom-src') || image.currentSrc || image.src; zoomImage.alt=image.alt || product.title || '';
      if (typeof dialog.showModal==='function') dialog.showModal(); else dialog.setAttribute('open','');
      if (zoomClose) zoomClose.focus();
    });
    if (zoomClose) zoomClose.addEventListener('click',function () { if (typeof dialog.close==='function') dialog.close(); else dialog.removeAttribute('open'); });
    if (dialog) {
      dialog.addEventListener('click',function (event) { if (event.target!==dialog) return; var r=dialog.getBoundingClientRect(); if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close(); });
      dialog.addEventListener('close',function () { if (zoomButton) zoomButton.focus(); });
    }
    var cashVisible=true, observer=null, raf=0;
    function stickyVisibility() { if (sticky) { var visible=mql.matches && !cashVisible; sticky.hidden=!visible; sticky.classList.toggle('is-visible',visible); } }
    function measureCash() { if (!buy) { cashVisible=true; stickyVisibility(); return; } var r=buy.getBoundingClientRect(); cashVisible=r.bottom>0 && r.top<window.innerHeight; stickyVisibility(); }
    function onScroll() { if (raf) return; raf=requestAnimationFrame(function () { raf=0; measureCash(); }); }
    if (sticky && buy && 'IntersectionObserver' in window) { observer=new IntersectionObserver(function (entries) { cashVisible=entries[0].isIntersecting; stickyVisibility(); },{threshold:0}); observer.observe(buy); }
    else if (sticky) window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',measureCash);
    if (mql.addEventListener) mql.addEventListener('change',stickyVisibility); else if (mql.addListener) mql.addListener(stickyVisibility);
    var requested=new URLSearchParams(location.search).get('variant');
    var initial=serverSelectionValid ? (highVariants ? variantById(root.dataset.currentVariant) : variantById(requested || root.dataset.currentVariant) || (!requested ? variants.find(function (v) { return v.available===true && Number(v.price)>0; }) || variants[0] : null)) : null;
    authoritativeVariant=highVariants ? initial : null;
    if (initial) selections=values(initial);
    else if (selects.length) selections=selects.map(function (el) { return String(el.value); });
    else optionButtons.forEach(function (button) { if (button.getAttribute('aria-pressed')==='true') selections[Number(button.dataset.optionIndex)]=String(button.dataset.optionValue); });
    if (!highVariants && requested && !variantById(requested)) selections=['__nonexistent_variant__'];
    mediaIndex=Math.max(0,media.findIndex(function (item) { return !item.hidden; }));
    showMedia(mediaIndex); render(false,true); measureCash();
    root.mtProductController={
      getState:function () { return Object.assign({},state); },
      refresh:function () { return render(true,false); },
      destroy:function () { disposed=true; requestGeneration++; if (fetchController) fetchController.abort(); if (fetchTimer) clearTimeout(fetchTimer); if (raf) cancelAnimationFrame(raf); if (dialog && dialog.open && typeof dialog.close==='function') dialog.close(); if (observer) observer.disconnect(); window.removeEventListener('resize',measureCash); window.removeEventListener('scroll',onScroll); if (mql.removeEventListener) mql.removeEventListener('change',stickyVisibility); else if (mql.removeListener) mql.removeListener(stickyVisibility); }
    };
  }
  function initializeAll() { document.querySelectorAll('[data-mt-product-root]').forEach(initialize); }
  window.MediaTechProductController={initialize:initialize,initializeAll:initializeAll};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initializeAll); else initializeAll();
  document.addEventListener('shopify:section:load',function (event) { if (event.target.matches('[data-mt-product-root]')) initialize(event.target); else event.target.querySelectorAll('[data-mt-product-root]').forEach(initialize); });
  document.addEventListener('shopify:section:unload',function (event) { event.target.querySelectorAll('[data-mt-product-root]').forEach(function (root) { if (root.mtProductController) root.mtProductController.destroy(); }); });
})();



